import React, { useState } from 'react';
import cn from 'classnames';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import ArrowDown from '@wix/da-ds/pkg/Icons/ArrowDown';
import ArrowUp from '@wix/da-ds/pkg/Icons/ArrowUp';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';

import s from './FieldsGroup.scss';

interface Props {
  className?: string;
  title?: React.ReactNode;
  titleClassName?: string;
  titleRight?: React.ReactNode;
  isCollapsible?: boolean;
  isCheckboxGroup?: boolean;
}

const FieldsGroup: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  className,
  title,
  titleClassName,
  titleRight,
  isCollapsible,
  isCheckboxGroup,
}) => {
  // if isCollapsible is true, fields will be collapsed by default on init
  const [isCollapsed, setIsCollapsed] = useState(isCollapsible);
  const fieldsVisible = !isCollapsible || !isCollapsed;
  const Arrow = isCollapsed ? ArrowDown : ArrowUp;
  return (
    <div
      className={cn(
        s['root'],
        isCollapsible && isCollapsed && s['root-collapsed'],
        isCollapsible && !isCollapsed && s['root-expanded']
      )}
    >
      {title && (
        <div className={cn(s['top'], titleClassName)}>
          <Heading className={s['title']}>
            {isCollapsible ? (
              <PlainButtonOrLink
                className={s['collapse-btn']}
                onClick={() => setIsCollapsed(!isCollapsed)}
              >
                {title}
                <Arrow className={s['collapse-icon']} size={IconSize.SMALL} />
              </PlainButtonOrLink>
            ) : (
              title
            )}
          </Heading>
          {titleRight}
        </div>
      )}
      <fieldset
        className={cn(
          s['fields'],
          !fieldsVisible && s['hidden'],
          isCheckboxGroup && s['checkbox-fields'],
          className
        )}
      >
        {children}
      </fieldset>
    </div>
  );
};
FieldsGroup.displayName = 'FieldsGroup';

export default FieldsGroup;
